module.exports = __webpack_public_path__ + "img/ali_pay_logo.bb629ee6.png";